import React, { useState } from 'react'
import TableActions from '../../UI/table/TableActions'
import StatusBadge from '../../UI/statusBadge'
import ShiftsModal from './shiftmodal'
import DataTable from '../../UI/table/DataTable'
import { useQuery, useMutation, useQueryClient } from 'react-query'
import { getShifts, deleteShifts, updateShifts } from '../../../MyApi/shifts'

const ShiftsTable = ({  onEdit, onDelete, onDisable ,isModalOpen ,closeModal,openModal ,id}) => {
  const [modalMode, setModalMode] = useState("add");
  const [selectedShift, setSelectedShift] = useState(null);
  const queryClient = useQueryClient();
   const [currentPage, setCurrentPage] = useState(1);
  const {data ,isLoading ,refetch}=useQuery(["getShifts", currentPage ,id],()=>getShifts(id, currentPage))
  const shifts =data?.data?.templates ||[]
  const totalItems = data?.data?.pagination?.total || 0;
  const itemsPerPage = data?.data?.pagination?.last_page || 0;

  const deleteMutation = useMutation({
    mutationFn: deleteShifts,
    onSuccess: () => {
      refetch();
    }
  });

  const handleEdit = (shift) => {
    setSelectedShift(shift);
    setModalMode("edit");
    openModal();
  };

  const handleShow = (shift) => {
    setSelectedShift(shift);
    setModalMode("view");
    openModal();
  };

  const handleDelete = (shiftId) => {
    deleteMutation.mutate(shiftId);
  };

  const columns = [
    {
      label: "اسم موعد العمل",
      accessor: "name"
    },
    {
      label: "الوقت",
      render: (shift) => (
        shift.days.every(day => !day.start_time && !day.end_time) ? (
          <span className="text-muted">Flexible (Work time)</span>
        ) : (
          shift.days.map((day) => (
            <div key={day.id}>
              <strong>{day.day_name}:</strong>{" "}
              {day.is_off_day ? (
                <span className="text-danger">Off</span>
              ) : (
                <>
                  {day.start_time} - {day.end_time}
                  <span className="text-secondary small ms-2">
                    ({day.total_hours}h)
                  </span>
                  <span>
                    ({day.break_duration} وقت راحة)
                  </span>
                </>
              )}
            </div>
          ))
        )
      )
    },
    {
      label: "التاريخ",
      accessor: "created_at"
    },
   {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      )
    },
    {
      label: "الإجراءات",
      render: (shift) => (
        <TableActions
          show={() => handleShow(shift)}
          edit={() => handleEdit(shift)}
          deleteFn={() => handleDelete(shift.id)}
          id={shift.id}
          viewPermission="view_couier_shift"
          editPermission="update_couier_shift"
          deletePermission="delete_couier_shift"
      
        />
      )
    }
  ];

  const handleAddClick = () => {
    setModalMode("add");
    setSelectedShift(null);  
    openModal();
  };

  return (
    <div className='row'>
      <ShiftsModal
        isOpen={isModalOpen}
        toggle={() => {
          closeModal();
          setModalMode("add");
          setSelectedShift(null);
        }}
        refetch={refetch}
        id={id}
        mode={modalMode}
        shiftData={selectedShift}
      />
      <DataTable
        title="مواعيد العمل"
        columns={columns}
        data={shifts}
        actionLabel="إضافة موعد عمل"
        onAddClick={handleAddClick}
        isLoading={isLoading}
        isFetching={isLoading}
        createPermission="create_couier_shift"
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      />
    </div>
  )
}

export default ShiftsTable
